<template>
  <!--
    NOTE: the reports columns are hidden because that permission works by user for all
    his/her devices, and not by device. The code is still here in the case the permission
    is modified to be by device.
  -->
  <v-container class="permissions-by-device-container">
    <Snackbar
      :text="snackbar.text"
      :color="snackbar.color"
      :timeOut="snackbar.timeOut"
      :show.sync="snackbar.show"
    />
    <v-row class="permissions-by-device">
      <v-col cols="12" sm="2" class="py-0" style="text-align: -webkit-center">
        <div class="img-div">
          <v-img class="profile-pic" id="profile-pic" width="100%" height="100%" :src="profilePicSrc"/>
        </div>
      </v-col>
      <v-col cols="12" sm="9" offset-sm="1" class="py-0" style="height: 100%;">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="title-text text-left">{{$t('PermissionsByDevice.title', [userData.name, $t(`Roles.${userData.role}`)])}}</p>
          </v-col>
        </v-row>
        <template v-if="devicesPermissions.length">
          <v-container class="table-container">
            <v-container class="table-div custom-scroll-bar">
              <v-row no-gutters class="pt-3 pb-1">
                <v-col offset="2">
                  <p class="header-text">{{$t('UsersPermissions.failure')}}</p>
                </v-col>
                <v-col>
                  <p class="header-text">{{$t('UsersPermissions.pressure')}}</p>
                </v-col>
                <v-col>
                  <p class="header-text">{{$t('UsersPermissions.off')}}</p>
                </v-col>
                <v-col>
                  <p class="header-text">{{$t('UsersPermissions.position')}}</p>
                </v-col>
                <v-col>
                  <p class="header-text">{{$t('UsersPermissions.irrigationOrders')}}</p>
                </v-col>
                <!-- <v-col>
                  <p class="header-text">{{$t('UsersPermissions.reports')}}</p>
                </v-col> -->
              </v-row>
              <v-row no-gutters justify="center">
                <v-col class="align-self-center">
                  <p class="row-text-bold my-0">{{$t('PermissionsByDevice.all')}}</p>
                </v-col>
                <v-col>
                  <v-switch
                    @click="changeAllPermissions('failure')"
                    v-model="allFailures"
                    inset
                    color="#00D166"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="changeAllPermissions('pressure')"
                    v-model="allPressure"
                    inset
                    color="#00D166"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="changeAllPermissions('off')"
                    v-model="allOff"
                    inset
                    color="#00D166"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="changeAllPermissions('position')"
                    v-model="allPosition"
                    inset
                    color="#00D166"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="changeAllPermissions('irrigationOrders')"
                    v-model="allIrrigationOrders"
                    inset
                    color="#00D166"
                  />
                </v-col>
                <!-- <v-col>
                  <v-switch
                    @click="changeAllPermissions('report')"
                    v-model="allReports"
                    inset
                    color="#00D166"
                  />
                </v-col> -->
              </v-row>
              <v-row v-for="device in devicesPermissions" :key="device.id" no-gutters justify="center">
                <v-col class="align-self-center">
                  <p class="row-text my-0">{{device.name}}</p>
                </v-col>
                <v-col>
                  <v-switch
                    @click="switchClick('failure')"
                    v-model="device.permissions.failure"
                    inset
                    color="#00D166"
                    :disabled="userData.permissionsCustomized"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="switchClick('pressure')"
                    v-model="device.permissions.pressure"
                    inset
                    color="#00D166"
                    :disabled="userData.permissionsCustomized"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="switchClick('off')"
                    v-model="device.permissions.off"
                    inset
                    color="#00D166"
                    :disabled="userData.permissionsCustomized"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="switchClick('position')"
                    v-model="device.permissions.position"
                    inset
                    color="#00D166"
                    :disabled="userData.permissionsCustomized"
                  />
                </v-col>
                <v-col>
                  <v-switch
                    @click="switchClick('irrigationOrders')"
                    v-model="device.permissions.irrigationOrders"
                    inset
                    color="#00D166"
                    :disabled="userData.permissionsCustomized"
                  />
                </v-col>
                <!-- <v-col>
                  <v-switch
                    @click="switchClick('report')"
                    v-model="device.permissions.report"
                    inset
                    color="#00D166"
                    :disabled="userData.permissionsCustomized"
                  />
                </v-col> -->
              </v-row>
            </v-container>
          </v-container>
          <v-row no-gutters class="mt-1">
            <v-col cols="3" offset="4">
              <v-btn
                @click="save"
                block
                color="#0098E1"
                large
                class="text-none text-h6 font-weight-light"
                dark
                :loading="loading"
              >{{fromNewUser ? $t('PermissionsByDevice.save') : $t('PermissionsByDevice.back')}}</v-btn>
            </v-col>
          </v-row>
        </template>
        <v-row v-else>
          <v-col cols="12">
            <p class="text-center empty-devices">{{$t('UsersPermissions.emptyDevicesList')}}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { insertNewUser } from '../../../lib/crudOperations/write'
  import Snackbar from '../../Shared/Snackbar.vue'
  import { DEFAULT_PERMISSIONS_BY_ROLE } from '../../../constants/const'
  import _sumBy from 'lodash/sumBy'
  import _cloneDeep from 'lodash/cloneDeep'
  import _sortBy from 'lodash/sortBy'
  import _isEmpty from 'lodash/isEmpty'

  export default {
    components: {
      Snackbar
    },
    props: {
      userData: {
        type: Object,
        required: true
      },
      permissionsByDeviceDialog: {
        type: Boolean,
        default: false
      },
      fromNewUser: {
        type: Boolean,
        default: false
      },
      devicesPermissionsProp: {
        type: Array,
        default: () => ([])
      }
    },
    data () {
      return {
        snackbar: {
          text: '',
          color: '',
          show: false,
          timeOut: 3000
        },
        loading: false,
        profilePicSrc: null,
        allFailures: null,
        allPressure: null,
        allOff: null,
        allPosition: null,
        allIrrigationOrders: null,
        devicesPermissions: []
        // allReports: null
      }
    },
    created () {
      this.devicesPermissions = []
      this.setUserImg()
      if (this.fromNewUser) {
        this.setNewUserDevicesPermissions()
      }
      this.setPermissionsByDevice()
    },
    methods: {
      setUserImg () {
        if (this.userData.photoUrl) {
          this.profilePicSrc = this.userData.profilePic
        } else {
          switch (this.userData.role) {
            case 'admin':
            case 'owner':
              this.profilePicSrc = require('../../../assets/owner.png')
              break
            case 'manager':
              this.profilePicSrc = require('../../../assets/manager.png')
              break
            case 'fieldman':
              this.profilePicSrc = require('../../../assets/fieldman.png')
              break
            case 'farmhand':
              this.profilePicSrc = require('../../../assets/farmhand.png')
              break
          }
        }
      },
      setPermissionsByDevice () {
        if (!_isEmpty(this.devicesPermissionsProp)) {
          this.devicesPermissions = _sortBy(_cloneDeep(this.devicesPermissionsProp), ['name'])
        }

        // Set counters by permission
        const permissionsCounters = {
          failure: _sumBy(this.devicesPermissions, device => device.permissions.failure ? 1 : 0),
          pressure: _sumBy(this.devicesPermissions, device => device.permissions.pressure ? 1 : 0),
          off: _sumBy(this.devicesPermissions, device => device.permissions.off ? 1 : 0),
          position: _sumBy(this.devicesPermissions, device => device.permissions.position ? 1 : 0),
          irrigationOrders: _sumBy(this.devicesPermissions, device => device.permissions.irrigationOrders ? 1 : 0)
          // report: _sumBy(this.devicesPermissions, device => device.permissions.report ? 1 : 0)
        }

        // Set allSelected flags
        if (this.devicesPermissions.length) {
          const propertiesMap = {
            failure: 'allFailures',
            pressure: 'allPressure',
            off: 'allOff',
            position: 'allPosition',
            irrigationOrders: 'allIrrigationOrders'
            // report: 'allReports'
          }

          Object.entries(propertiesMap).forEach(([key, property]) => {
            if (permissionsCounters[key] === this.devicesPermissions.length) {
              this[property] = true
            }
          })
        }
      },
      changeAllPermissions (permission) {
        let newValue
        switch (permission) {
          case 'failure':
            newValue = this.allFailures
            break
          case 'pressure':
            newValue = this.allPressure
            break
          case 'off':
            newValue = this.allOff
            break
          case 'position':
            newValue = this.allPosition
            break
          case 'irrigationOrders':
            newValue = this.allIrrigationOrders
            break
          // case 'report':
          //   newValue = this.allReports
          //   break
        }
        this.devicesPermissions.forEach(device => {
          device.permissions[permission] = newValue
        })
      },
      switchClick (permission) {
        switch (permission) {
          case 'failure':
            if (this.allFailures) {
              this.allFailures = false
            }
            break
          case 'pressure':
            if (this.allPressure) {
              this.allPressure = false
            }
            break
          case 'off':
            if (this.allOff) {
              this.allOff = false
            }
            break
          case 'position':
            if (this.allPosition) {
              this.allPosition = false
            }
            break
          case 'irrigationOrders':
            if (this.allIrrigationOrders) {
              this.allIrrigationOrders = false
            }
            break
          // case 'report':
          //   if (this.allReports) {
          //     this.allReports = false
          //   }
          //   break
        }
      },
      async save () {
        try {
          this.loading = true
          if (this.fromNewUser) {
            await insertNewUser(this.userData, this.userData.assignedDevices, this.devicesPermissions)
            this.$router.push({name: 'OrganizationHome'})
            this.$root.snack.show({text: this.$t('UI.registerSuccess')})
          } else {
            this.$emit('update:permissionsByDeviceDialog', false)
          }
        } catch (error) {
          this.snackbar = {
            ...this.snackbar,
            show: true,
            text: this.$t('UI.serverError'),
            color: 'error'
          }
        } finally {
          this.loading = false
        }
      },
      setNewUserDevicesPermissions () {
        const devicesPermissions = []
        const permissionsByRole = DEFAULT_PERMISSIONS_BY_ROLE[this.userData.role]
        this.userData.assignedDevices.filter(device => device.isAssigned).map(device => device.id).forEach(deviceID => {
          const device = this.$store.getters.devices.find(elem => elem.id === deviceID)
          if (!device) return

          devicesPermissions.push({
            id: deviceID,
            name: device.campaign.entityName,
            permissions: {
              failure: !!permissionsByRole.includes('failure'),
              pressure: !!permissionsByRole.includes('pressure'),
              off: !!permissionsByRole.includes('off'),
              position: !!permissionsByRole.includes('position'),
              irrigationOrders: !!permissionsByRole.includes('irrigationOrders'),
            }
          })
        })
        this.devicesPermissions = devicesPermissions
      }
    },
    beforeDestroy () {
      this.$emit('update:devicesPermissionsProp', this.devicesPermissions)
    }
  }
</script>



// WEBPACK FOOTER //
// PermissionsByDevice.vue?469a619a